module.exports = __webpack_public_path__ + "img/login_page_bac0.17e090fc.jpg";